import { render, staticRenderFns } from "./bottomIntroduce.vue?vue&type=template&id=ce4a909e&scoped=true&"
import script from "./bottomIntroduce.vue?vue&type=script&lang=js&"
export * from "./bottomIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./bottomIntroduce.vue?vue&type=style&index=0&id=ce4a909e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4a909e",
  null
  
)

export default component.exports